document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  document.querySelectorAll('[data-product-gallery-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const main = document.querySelector('[data-product-gallery-main] img');
      if (main && btn.dataset.src) main.src = btn.dataset.src;
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const price = document.querySelector('[data-product-price]');
    if (!select) return;
    select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    });
  });
});
